var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnumeratorsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333374,
    y: 0.851562,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#EEF2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13337_11718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6734 27.7082V20.4951C35.6734 19.2131 34.6341 18.1738 33.3521 18.1738H22.4024C21.1203 18.1738 20.0811 19.2131 20.0811 20.4951V47.5279M17.5186 47.5288H28.8757M20.0811 24.1359H25.7042M20.0811 29.993H28.8757M33.4273 47.5279C33.4395 46.358 33.7459 45.2104 34.3182 44.1921C35.524 42.0463 37.8399 40.6837 40.2885 40.6783C42.7369 40.6837 45.0528 42.0463 46.2588 44.1921C46.8309 45.2104 47.1374 46.358 47.1495 47.5279M40.2885 39.7816C42.4981 39.7816 44.2892 37.9903 44.2892 35.7807C44.2892 33.5711 42.4981 31.7799 40.2885 31.7799C38.0788 31.7799 36.2876 33.5711 36.2876 35.7807C36.2876 37.9903 38.0788 39.7816 40.2885 39.7816Z",
    stroke: "#5770CB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13337_11718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16.3334 16.8516)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnumeratorsIcon);
export default __webpack_public_path__ + "static/media/enumerators-icon.1d23fecd.svg";
export { ForwardRef as ReactComponent };